import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTimer } from 'react-timer-hook';
import { change, Field } from 'redux-form';
import { formatCountdown } from '../../../utils/format';
import Banner from '../../elements/Banner';
import Button from '../../elements/Button';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import LoadingBars from '../../elements/LoadingBars';
import RadioList from '../../elements/RadioList';
import Text from '../../fields/Text';
import TextArea from '../../fields/TextArea/TextArea';
import IconDownloadCsv from '../../icons/IconDownloadCsv';
import IconFailed from '../../icons/IconFailed';
import styles from './styles.scoped.css';

export function FormAddBusinessType({ handleSubmit, handleReset, valid }){
  const dispatch = useDispatch();

  const [file, setFile] = useState([]);
  const [error, setError] = useState('');
  const { values } = useSelector((state) => state.form.FormAddBusinessType);
  const {
    dataSubmitAddBusinessType, messageSubmitAddBusinessType, isLoadingSubmitAddBusinessType,
  } = useSelector((state) => state.settingBusinessType);

  const dateNow = new Date();
  const { minutes, seconds, restart } =
    useTimer({
      expiryTimestamp: dateNow,
      onExpire: () => handleReset(),
      autoStart: true
    });

  useEffect(() => {
    if (dataSubmitAddBusinessType?.code === 429) {
      const countdownTime = dataSubmitAddBusinessType?.data?.countdownTime;
      if (countdownTime) {
        const newExpiry = new Date();
        newExpiry.setSeconds(newExpiry.getSeconds() + countdownTime);
        restart(newExpiry);
      }
    }
  }, [dataSubmitAddBusinessType]);

  const enableSubmit = () => {
    if(values?.options === '1'){
      return valid && values?.businessTypeName && values?.codeKbli
      && values?.kbliVersion && values?.description;
    } else {
      return file.length > 0;
    }
  };

  const downloadTemplate = () => {
    // TODO: ganti URL ke template CSV baru (kolom VERSI KBLI, KODE KBLI, JENIS USAHA, DESKRIPSI)
    window.open('https://storage.googleapis.com/fin-map-images-public-stage/templates/template-jenis-usaha-v2.csv');
  };

  const onSubmit = async(e) => {
    e.preventDefault();
    const body = {
      type: values.options,
      name: values.businessTypeName.trim(),
      codeKbli: values.codeKbli,
      kbliVersion: values.options === '1' ? values.kbliVersion : undefined,
      description: values.description,
      file: file,
    };
    handleSubmit(body);
  };

  useEffect(() => {
    if(!/^[0-9]*$/.test(values.codeKbli)){
      const codeKbli = values.codeKbli.replace(/[^0-9]/g, '');
      dispatch(change('FormAddBusinessType', 'codeKbli', codeKbli));
    }
  }, [values.codeKbli]);

  useEffect(() => {
    if(!dataSubmitAddBusinessType.success && messageSubmitAddBusinessType && values.options === '2'){
      setError(messageSubmitAddBusinessType);
    }
  }, [dataSubmitAddBusinessType, messageSubmitAddBusinessType]);

  useEffect(() => {
    setError('');
  }, [values, file]);

  useEffect(() => {
    if (dataSubmitAddBusinessType?.code === 409) {
      handleReset();
    }
  }, [values.codeKbli, values.businessTypeName]);

  return(
    <form onSubmit={onSubmit}>
      <div className={styles.radioField}>
        <Field
          component={RadioList}
          inputProps={{
            label: 'Opsi Menambahkan Jenis Usaha',
            required: true,
            defaultValue: values?.options,
          }}
          items={[
            { label: 'Teks', value: '1' },
            { label: 'Bulk CSV', value: '2' },
          ]}
          name={'options'}
        />
      </div>
      {values?.options === '2' ? (
        <div>
          <ImagePicker
            accept={['text/csv']}
            downloadTemplate={downloadTemplate}
            IconDownloadTemplate={<IconDownloadCsv/>}
            info={'Format file .csv dan tidak lebih dari 2 Mb'}
            maxSize={2000000}
            onSelect={setFile}
            required={true}
            title={'Unggah Data Jenis Usaha'}
            withDownloadTemplate={true}
          />
          {dataSubmitAddBusinessType?.code === 429 && (
            <Banner
              desc={<span>
                Sudah submit CSV 5 kali dalam satu menit. Anda dapat submit file CSV
                kembali setelah <strong>{formatCountdown(minutes, seconds)}</strong></span>
              }
              icon={<IconFailed />}
              type={'danger'} />
          )}
          {dataSubmitAddBusinessType?.code !== 429 && error && (
            <Banner
              desc={error}
              icon={<IconFailed />}
              type={'danger'} />
          )}
        </div>
      ) : (
        <>
          <div className={styles.radioField}>
            <Field
              component={RadioList}
              inputProps={{
                label: 'Tahun KBLI',
                required: true,
                defaultValue: values?.kbliVersion,
              }}
              items={[
                { label: '2020', value: '2020' },
                { label: '2025', value: '2025' },
              ]}
              name={'kbliVersion'}
            />
          </div>
          <Field
            autoComplete="off"
            component={Text}
            inputProps={{
              label: 'Kode KBLI',
              required: true,
              placeholder: 'Masukkan kode KBLI',
              maxLength: 10,
            }}
            isErrorField={dataSubmitAddBusinessType?.code === 409}
            name={'codeKbli'}
            required={true}
          />
          <Field
            autoComplete="off"
            component={Text}
            inputProps={{
              label: 'Jenis Usaha',
              required: true,
              placeholder: 'Masukkan Jenis Usaha',
            }}
            isErrorField={dataSubmitAddBusinessType?.code === 409}
            name={'businessTypeName'}
            required={true}
            serverError={dataSubmitAddBusinessType?.code === 409
              ? messageSubmitAddBusinessType : ''}
          />
          <Field
            cols={10}
            component={TextArea}
            inputProps={{
              label: 'Deskripsi',
              required: true,
              placeholder: 'Masukkan deskripsi jenis usaha',
            }}
            maxLength={100}
            // meta={{ error: syncErrors?.description }}
            name={'description'}
            required={true}
            // showErrorWithoutTouched={true}
          />
        </>
      )}
      <Button
        className={styles.action}
        disabled={!enableSubmit() || isLoadingSubmitAddBusinessType || error}
        fullWidth
        style={'blue'}
        type={'submit'}>
        {isLoadingSubmitAddBusinessType && <LoadingBars size={1} />}
          Tambah
      </Button>
    </form>
  );
}

export default FormAddBusinessType;

FormAddBusinessType.propTypes = {
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
};

